<template>
  <header class="topbar">
    <div class="with-vertical">
      <nav class="navbar navbar-expand-lg p-0">
        <ul class="navbar-nav">
          <li class="nav-item nav-icon-hover ms-n3">
            <a class="nav-link sidebartoggler" id="headerCollapse" href="javascript:void(0)">
              <iconify-icon icon="solar:hamburger-menu-line-duotone" class="fs-7"></iconify-icon>
            </a>
          </li>
        </ul>

        <div class="d-block d-lg-none">
          <img src="@/assets/images/logo.png" class="dark-logo" width="180" alt="MaterialM-img" />
        </div>

        <a class="navbar-toggler p-0 border-0 nav-icon-hover" href="javascript:void(0)" data-bs-toggle="collapse"
          data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="p-2">
            <i class="ti ti-dots fs-7"></i>
          </span>
        </a>

        <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
          <div class="d-flex align-items-center justify-content-between">
            <ul class="navbar-nav flex-row mx-auto ms-lg-auto align-items-center justify-content-center">
              <li class="nav-item nav-icon-hover dropdown">
                <a href="javascript:void(0)" class="nav-link d-flex d-lg-none align-items-center justify-content-center"
                  type="button" data-bs-toggle="offcanvas" data-bs-target="#mobilenavbar"
                  aria-controls="offcanvasWithBothOptions">
                  <iconify-icon icon="solar:sort-line-duotone" class="fs-7"></iconify-icon>
                </a>
              </li>
              <li class="nav-item nav-icon-hover d-block">
                <!-- Ícone da lua (Modo escuro) -->
                <span class="nav-link moon dark-layout" role="button" v-if="theme == 'light'"
                  @click="setTheme('dark')">
                  <iconify-icon icon="solar:moon-line-duotone" class="moon fs-6"></iconify-icon>
                </span>

                <!-- Ícone do sol (Modo claro) -->
                <span class="nav-link sun light-layout" role="button" v-if="theme == 'dark'"
                  @click="setTheme('light')">
                  <iconify-icon icon="solar:sun-2-line-duotone" class="sun fs-6"></iconify-icon>
                </span>
              </li>
              <li class="nav-item nav-icon-hover d-none d-xl-none">
                <a class="nav-link" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                  <iconify-icon icon="solar:magnifer-line-duotone" class="fs-6"></iconify-icon>
                </a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link" href="javascript:void(0)" id="drop1" aria-expanded="false">
                  <div class="d-flex align-items-center gap-2 lh-base">
                    <img src="@/assets/images/profile/user-1.jpg" class="rounded-circle" width="35" height="35"
                      alt="MaterialM-img" />
                  </div>
                </a>
                <div class="dropdown-menu content-dd dropdown-menu-end dropdown-menu-animate-up"
                  aria-labelledby="drop1">
                  <div class="profile-dropdown position-relative" data-simplebar>
                    <div class="py-3 px-7 pb-0">
                      <h5 class="mb-0 fs-5 fw-semibold">Perfil</h5>
                    </div>
                    <div class="d-flex align-items-center py-9 mx-7 border-bottom">
                      <img src="@/assets/images/profile/user-1.jpg" class="rounded-circle" width="80" height="80"
                        alt="MaterialM-img" />
                      <div class="ms-3">
                        <h5 class="mb-0 fs-4">{{ individual.name }}</h5>
                        <span class="mb-1 d-block">{{ individual.role.name }}</span>
                      </div>
                    </div>
                    <!-- <div class="message-body">
                      <a href="./main/page-user-profile.html" class="py-8 px-7 mt-8 d-flex align-items-center">
                        <span
                          class="d-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded round">
                          <iconify-icon icon="solar:wallet-2-line-duotone" class="fs-7"></iconify-icon>
                        </span>
                        <div class="w-75 v-middle ps-3">
                          <h5 class="mb-1 fs-3 fw-medium">Meu Perfil</h5>
                          <span class="fs-2 d-block text-body-secondary">Configurações
                            da conta</span>
                        </div>
                      </a>
                    </div> -->
                    <div class="d-grid py-4 px-7 pt-8">
                      <span @click="logout" role="button" class="btn btn-primary">Sair</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </nav>
    </div>

  </header>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'HeaderBar',
  data() {
    return {
      individual: null,
      theme: Cookies.get("theme") || "light"
    }
  },
  methods: {
    logout() {
      Cookies.remove("_token")
      this.$router.push('/auth')
    },
    setTheme(theme) {
      this.theme = theme;
      Cookies.set("theme", theme);
      document.documentElement.setAttribute("data-bs-theme", theme);
      this.toggleElements(theme);
    },
    toggleElements(theme) {
      const darkDisplay = theme === "dark" ? "dark-logo" : "light-logo";
      const lightDisplay = theme === "dark" ? "light-logo" : "dark-logo";
      const sunDisplay = theme === "dark" ? "moon" : "sun";
      const moonDisplay = theme === "dark" ? "sun" : "moon";

      document.querySelectorAll(`.${darkDisplay}`).forEach((el) => (el.style.display = "none"));
      document.querySelectorAll(`.${lightDisplay}`).forEach((el) => (el.style.display = "flex"));
      document.querySelectorAll(`.${sunDisplay}`).forEach((el) => (el.style.display = "none"));
      document.querySelectorAll(`.${moonDisplay}`).forEach((el) => (el.style.display = "flex"));
    },
  },
  created() {
    const savedTheme = Cookies.get("theme");

    if (!savedTheme) {
      this.setTheme("light");
    } else {
      this.setTheme(savedTheme);
    }

    this.individual = JSON.parse(Cookies.get('individual'));
  }
}
</script>